import { useStaticQuery, graphql } from 'gatsby'

export const useSiteMeta = () => {
  const siteMeta = useStaticQuery(
    graphql`
      query SiteMeta {
        site {
          siteMetadata {
            title
            description
            email
            facebookUrl
            siteKey
          }
        }
      }
    `
  )

  return siteMeta.site.siteMetadata
}
